import React from 'react'
import "./Rowpack.css"

export default function Rowpack() {
  return (
    <div className='row'>
      <h1>Title</h1>

      <div className="posters">
        <img src="https://images.squarespace-cdn.com/content/v1/59232e19579fb3fa44a693c2/1589212826160-UM9PEPGOS3OJPR0FJ81X/ke17ZwdGBToddI8pDm48kHZUaJeKzodyg_sXWBMxNTdZw-zPPgdn4jUwVcJE1ZvWQUxwkmyExglNqGp0IvTJZUJFbgE-7XRK3dMEBRBhUpxCBUU7B-_SAG1kGvCwYgmUjQXvn8_OJjtz3K1llMQBa1MPsuSXPSY3X-tgg78M7lI/SKOyqL1qFLIhbK6ho2lB-696x975.jpg?format=1500w'
" alt="films" className="films" />
<img src="https://m.media-amazon.com/images/M/MV5BZGE4Y2Q5MzAtY2FlYS00M2ZiLWJlMjMtOWNhMzMwYjU2Y2UwXkEyXkFqcGc@._V1_QL75_UX480_.jpg"
 alt="films" className="films" />

<img src="https://i.pinimg.com/originals/8c/59/8e/8c598e23041ab30f831e8ae8ecb3ac8a.jpg
" alt="films" className="films" />

<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8jUrFsn_RO8fWr9VeV4Dg-EppHPbCnUgZ9V6DLtzlVkzEMdjahQte82ZQKoSr149Upxk&usqp=CAU'
" alt="films" className="films" />

<img src="https://m.media-amazon.com/images/M/MV5BNWU1ZWFhNGQtZDhlZC00ZWFlLTlmNmEtN2VmYmZiN2Y5ZmQ2XkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg'
" alt="films" className="films" />

<img src="https://m.media-amazon.com/images/M/MV5BN2I3ODdiYjYtZjBlMC00NjAwLTljODctZjIwYmM0NGVkYTUxXkEyXkFqcGc@._V1_.jpg'
" alt="films" className="films" />

<img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/dbee4693-86bc-4245-a2a3-2766faf8080a/de6ew8g-0896360e-ff5c-4962-808b-e9b867936fc2.jpg/v1/fill/w_1280,h_1821,q_75,strp/kurup_malayalam_movie_custom_poster_by_subinraj_de6ew8g-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTgyMSIsInBhdGgiOiJcL2ZcL2RiZWU0NjkzLTg2YmMtNDI0NS1hMmEzLTI3NjZmYWY4MDgwYVwvZGU2ZXc4Zy0wODk2MzYwZS1mZjVjLTQ5NjItODA4Yi1lOWI4Njc5MzZmYzIuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.i581_7C7UKYLqlVFHMvR3x9DkTrgEIS2NbhzFP534Ww" alt="films" className="films" />

<img src="https://images.squarespace-cdn.com/content/v1/59232e19579fb3fa44a693c2/1589212826160-UM9PEPGOS3OJPR0FJ81X/ke17ZwdGBToddI8pDm48kHZUaJeKzodyg_sXWBMxNTdZw-zPPgdn4jUwVcJE1ZvWQUxwkmyExglNqGp0IvTJZUJFbgE-7XRK3dMEBRBhUpxCBUU7B-_SAG1kGvCwYgmUjQXvn8_OJjtz3K1llMQBa1MPsuSXPSY3X-tgg78M7lI/SKOyqL1qFLIhbK6ho2lB-696x975.jpg?format=1500w'
" alt="films" className="films" />

<img src="https://images.squarespace-cdn.com/content/v1/59232e19579fb3fa44a693c2/1589212826160-UM9PEPGOS3OJPR0FJ81X/ke17ZwdGBToddI8pDm48kHZUaJeKzodyg_sXWBMxNTdZw-zPPgdn4jUwVcJE1ZvWQUxwkmyExglNqGp0IvTJZUJFbgE-7XRK3dMEBRBhUpxCBUU7B-_SAG1kGvCwYgmUjQXvn8_OJjtz3K1llMQBa1MPsuSXPSY3X-tgg78M7lI/SKOyqL1qFLIhbK6ho2lB-696x975.jpg?format=1500w'
" alt="films" className="films" />




      </div>
    </div>
  )
}
